import { createSelector } from 'reselect';
import { getAnalysisValueForGoalAndGroup } from '../../utils/analysisUtils';
import { getKeyAdoptionGoalsByArea } from './adoptionSelectors';

function getGroupsForGoal(allGroups, allValues, goal, goalStatus) {
  return allGroups
    .filter((group) => getAnalysisValueForGoalAndGroup(goal.id, group.id, allValues) === goalStatus);
}

export const makeGetCombinedTabularRecommendations = status => createSelector(
  [getKeyAdoptionGoalsByArea],
  (keyAdoptionGoalsByArea) => {
    let rows = [];

    keyAdoptionGoalsByArea
      .forEach(area => (
        area.goals.forEach(goal => (
          rows.push({
            area: area.area,
            goal,
            groups: getGroupsForGoal(area.groups, area.values, goal, status),
            status
          })
        ))
      ));

    return rows.filter(row => row.groups.length > 0);
  }
);



// WEBPACK FOOTER //
// ./src/selectors/analytics/recommendationSelectors.js